module.exports = __webpack_public_path__ + "assets/img/collect-cards-light4.1687d514.png";